/**
 * localStorage key for the Ramp Loss Calculator's five slider memories.
 *
 * Lives here, away from the page, so `authReducer` can clear it on logout
 * without pulling recharts and react-i18next into the auth module graph. Every
 * other persisted key in this app is removed by its own logout reducer; these
 * presets are not a redux slice, so this is their equivalent.
 */
export const RAMP_LOSS_PRESET_STORAGE_KEY = 'rampLossPresets';
